import * as DomUtil from './core/DomUtil'
import * as NumberUtil from './core/number-util'

export const STORAGE_PREFIX = '@buybot'
export const SAFE_AREA_BOTTOM =
  NumberUtil.safeParseFloat(
    DomUtil.getCssVarValue('--safe-area-inset-bottom'),
  ) ?? 0

export const SAFE_AREA_TOP =
  NumberUtil.safeParseFloat(DomUtil.getCssVarValue('--safe-area-inset-top')) ??
  0
